import React from 'react';
import Icon from '../../Icon';

function TableActionButton(props) {
  return (
    <div className='flex gap-2'>
      <button
        onClick={props.clickedView}
        className={`w-8 h-8 bg-blue-400 hover:opacity-80 ${
          props.display.includes('view') ? 'flex' : 'hidden'
        } justify-center items-center rounded-md`}
      >
        <Icon name='eye-solid' className='w-[1rem] h-[1rem] fill-white' />
      </button>

      <button
        onClick={props.clickedEdit}
        className={`w-8 h-8 bg-green-400 ${
          props.display.includes('edit') ? 'flex' : 'hidden'
        } hover:opacity-80 flex justify-center items-center rounded-md`}
      >
        <Icon name='edit' className='w-[1rem] h-[1rem] fill-white' />
      </button>

      <button
        onClick={props.clickedDelete}
        className={`w-8 h-8 bg-red-400 ${
          props.display.includes('delete') ? 'flex' : 'hidden'
        } hover:opacity-80 flex justify-center items-center rounded-md`}
      >
        <Icon name='deleteBin' className='w-[1rem] h-[1rem] fill-white' />
      </button>
    </div>
  );
}

export default TableActionButton;
